import { getProductsStationChainSuggestions } from '@/api/generated/products-station-chains/products-station-chains';
import type { ListRequest, StationChainSuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';
import { createAsyncSelectorField } from '@/shared/forms';
import type { StationChainRef } from '../productsApi';

/**
 * Selektor tras (StationChain) pro přiřazení linky k termínu. Trasa je Phoenix-owned entita s Guid klíčem
 * — resolve-by-ids posílá id beze změny (stringifikuje je `toListRequest`, BE parsuje dle bindingu).
 */
const stationChainSelector = defineEntityAsyncSelector<
  StationChainRef,
  StationChainSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getProductsStationChainSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('products.station-chains.suggestions', request),
    mapItem: (s) => ({
      stationChainId: s.id,
      name: s.name,
      code: s.code ?? null,
      isReturn: s.isReturn,
    }),
  },
  key: (item) => item.stationChainId,
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('stationChainSelectors.chain.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'code',
        header: t('stationChainSelectors.chain.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'products' },
});

export const StationChainSelector = stationChainSelector.Selector;

/** Pole trasy pro TanStack Form (single). */
export const StationChainSelectorField = createAsyncSelectorField(StationChainSelector);
